<template>
	<section
		:class="[
			'explore-technology-container marketing-section bg-color-content-primary text-color-greige',
			{
				'bg-img-dotted-waves': !appStore.isMobile
			}
		]"
	>
		<article class="container">
			<div
				class="display-flex justify-content-space-between flex-wrap-wrap-smo gap-900-md gap-400-smo align-items-flex-end"
			>
				<div class="col-7-md col-6-xl">
					<h2 class="heading-xl mb-200-md mb-150-smo">
						<slot name="heading"></slot>
					</h2>
					<slot name="content"></slot>
					<BaseLink
						classes="button button-outline-reversed mt-200-md mt-150-smo width-100-smo"
						:link="{ router: 'why-fundrise' }"
					>
						Learn about our technology
					</BaseLink>
				</div>
				<div class="col-4-md">
					<slot name="list"></slot>
				</div>
			</div>
		</article>
	</section>
</template>
<script setup lang="ts">
import { useAppStore } from '@stores/app';

const appStore = useAppStore();
</script>
<style lang="scss" scoped>
@use '../../styles/utilities/respond-to.scss' as *;

@include respond-to(md) {
	.gap-900-md {
		gap: 9rem;
	}
}
</style>
